import styles from './MessagesList.module.css';
import Message from '../Message/Message';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

const MessagesList = ({
  messages,
  phoneNumberFontSize,
  authorFontSize,
  msgFontSize,
  currentState,
  winId,
  speed,
  winIds,
}) => {
  return (
    <div className={styles['wrapper']}>
      {/* <div className={styles['line']}></div> */}
      {/* <div className={styles['winnerWord']}>
        <CSSTransition
          in={currentState === 'S4'}
          timeout={500}
          classNames="fade-scale"
          unmountOnExit>
          <span>ПОБЕДИТЕЛЬ</span>
        </CSSTransition>
      </div> */}
      {currentState &&
        (currentState === 'S2' ||
          currentState === 'S3' ||
          (['S4', 'S5', 'S6', 'S7', 'S8', 'S9'].includes(currentState) &&
            messages.length > 3)) && (
          <div className={styles['messagesWrapper']}>
            <TransitionGroup className={styles['messages']} appear={true}>
              {messages.length > 0 &&
                messages.map((item, i) => (
                  <CSSTransition
                    key={item.UUID}
                    timeout={speed}
                    classNames="position">
                    <Message
                      winId={winId}
                      key={item.id}
                      message={item.message}
                      titrTag={item.titrTag}
                      authorFontSize={authorFontSize}
                      msgFontSize={msgFontSize}
                      phoneNumberFontSize={phoneNumberFontSize}
                      currentState={currentState}
                      winIds={winIds}
                    />
                  </CSSTransition>
                ))}
            </TransitionGroup>
          </div>
        )}
    </div>
  );
};

export default MessagesList;
